'use strict';

exports.__esModule = true;

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PageLayout = (_temp2 = _class = function (_Component) {
  _inherits(PageLayout, _Component);

  function PageLayout() {
    var _temp, _this, _ret;

    _classCallCheck(this, PageLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PageLayout.prototype.getPaginationData = function getPaginationData() {
    var _props = this.props,
        first = _props.first,
        where = _props.where;
    var uri = this.context.uri;

    var _uri$query = uri.query(true),
        page = _uri$query.page;

    var skip = void 0;
    page = page && parseInt(page) || 0;

    if (first && page > 1) {
      skip = (page - 1) * first;
    }

    return {
      first: first,
      skip: skip,
      page: page
    };
  };

  PageLayout.prototype.render = function render(content) {
    return content || null;
  };

  return PageLayout;
}(_react.Component), _class.defaultProps = {}, _class.contextType = _context2.default, _temp2);
PageLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  connectors: _propTypes2.default.array,
  View: _propTypes2.default.func.isRequired
} : {};
exports.default = PageLayout;
module.exports = exports['default'];